import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

const aiActions = defineAIActions({
  namespace: 'ai-studio',
  actions: [
    {
      id: 'generate-content',
      name: '生成内容',
      description: '使用AI生成小红书笔记内容',
      parameters: [
        { name: 'topic', type: 'string', description: '内容主题', required: true },
        { name: 'style', type: 'string', description: '写作风格', required: false },
        { name: 'length', type: 'string', description: '内容长度', required: false },
      ],
      handler: async (params) => {
        return {
          type: 'content',
          data: { content: '这是AI生成的内容示例...' },
          message: '内容生成成功',
        };
      },
    },
    {
      id: 'generate-title',
      name: '生成标题',
      description: '为笔记生成吸引人的标题',
      parameters: [
        { name: 'content', type: 'string', description: '笔记内容', required: true },
        { name: 'count', type: 'number', description: '生成数量', required: false },
      ],
      handler: async () => {
        return {
          type: 'list',
          data: ['标题1', '标题2', '标题3'],
          message: '生成了3个标题供选择',
        };
      },
    },
    {
      id: 'optimize-content',
      name: '优化内容',
      description: '优化现有内容的表达和吸引力',
      parameters: [
        { name: 'content', type: 'string', description: '原始内容', required: true },
      ],
      handler: async () => {
        return {
          type: 'content',
          data: { content: '优化后的内容...' },
          message: '内容优化完成',
        };
      },
    },
  ],
});

export default definePlugin({
  meta: {
    name: 'ai-studio',
    version: '1.0.0',
    displayName: 'AI工作室',
    description: 'AI内容生成、提示词管理、智能助手',
    icon: 'sparkles',
    category: 'ai',
  },

  onLoad: async () => {
    console.log('[Plugin] AI Studio loaded');
  },

  onUnload: () => {
    console.log('[Plugin] AI Studio unloaded');
  },

  routes: [
    {
      path: '/ai-studio',
      lazy: async () => {
        const { AIStudioHome } = await import('./pages/AIStudioHome');
        return { Component: AIStudioHome };
      },
    },
    {
      path: '/ai-studio/generate',
      lazy: async () => {
        const { ContentGenerator } = await import('./pages/ContentGenerator');
        return { Component: ContentGenerator };
      },
    },
    {
      path: '/ai-studio/prompts',
      lazy: async () => {
        const { PromptLibrary } = await import('./pages/PromptLibrary');
        return { Component: PromptLibrary };
      },
    },
    {
      path: '/ai-studio/prompts/new',
      lazy: async () => {
        const { PromptEditor } = await import('./pages/PromptEditor');
        return { Component: PromptEditor };
      },
    },
    {
      path: '/ai-studio/history',
      lazy: async () => {
        const { GenerationHistory } = await import('./pages/GenerationHistory');
        return { Component: GenerationHistory };
      },
    },
  ],

  sidebarMenus: [
    {
      id: 'ai-studio',
      title: 'AI工作室',
      icon: 'sparkles',
      path: '/ai-studio',
      order: 7,
    },
  ],

  aiActions,
});

